import React, { FC, useEffect } from 'react'

import NameStep from './steps/name/NameStep'
import LocationStep from './steps/location/LocationStep'
import AgendasStep from './steps/agendas/AgendasStep'
import GifStep from './steps/gif/GifStep'
import CompanyStep from './steps/company/CompanyStep'
import Completed from './steps/completed/Completed'
import RangeStep from './steps/ranges/RangeStep'

import { showHeader } from '../../store/general/actions'

import './styles.scss'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { IProps } from './types'
import { setSteps } from '../../store/onboarding/actions'
import { OnboardingSteps } from '../../store/onboarding/types'
import { Routes } from '../../routing/routes'
import { Plann3rStore } from '../../store/types'

const OnboardingFlow: FC<IProps> = ({ headerVisible = false, new_steps }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (new_steps) dispatch(setSteps(new_steps))
    if (!headerVisible) dispatch(showHeader(false))
    if (headerVisible) dispatch(showHeader(true))
  }, [new_steps, headerVisible, dispatch])

  const { step } = useSelector((state: Plann3rStore) => state.onboarding)

  let content
  switch (step) {
    case OnboardingSteps.AGENDAS:
      content = <AgendasStep />
      break

    case OnboardingSteps.CONNECTED:
      content = <GifStep />
      break

    case OnboardingSteps.NAME:
      content = <NameStep />
      break

    case OnboardingSteps.LOCATION:
      content = <LocationStep />
      break

    case OnboardingSteps.RANGES:
      content = <RangeStep />
      break

    case OnboardingSteps.COMPLETED:
      content = <Completed />
      break

    case OnboardingSteps.CLAIMED:
      history.push(Routes.PAGES_MANAGEMENT + '?product_tour_id=9641')
      content = ''
      break

    case OnboardingSteps.COMPANY:
      content = <CompanyStep />
      break

    default:
      content = ''
      break
  }

  return <div className="onboarding columns styles mb-8 h-full">{content}</div>
}

export default OnboardingFlow
